function getLatestStateValue(setState) {
    let items = {};
    setState((old)=>{
      items = old;
      return old;
    });
    return items;
  }
  
  export default getLatestStateValue;